import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  CssBaseline,
  Link
} from "@mui/material";
import AppRoutes from "./routes";
import "./App.css";

function App() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title> Policy Monitoring Tool</title>
      </Helmet>

      <Router>
        <CssBaseline />
        <AppBar position="fixed" padding="0" margin="0">
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              height: "3rem",
              backgroundColor: "#e9f3f3",
            }}
          >
            <Box>
              <Link
                href="/pmt"
                style={{ textDecoration: "none", color: "inherit", padding: "0 1rem" }} // Add some padding for separation
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ color: "yellowgreen", fontWeight: "bold" }}
                >
                  Policy Monitoring Tool
                </Typography>
              </Link>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Link
                href="https://quantifarmtoolkit.eu/index.html"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src="/pmt/quantifarm-logo.png"
                  alt="Logo"
                  style={{ height: "3.5rem", marginTop: "7px" }}
                />
              </Link>
              <Link
                href="https://commission.europa.eu/index_en"
                target="_blank"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src="/pmt/logo-en-euc.png"
                  alt="Eu-Commision-Logo"
                  style={{ height: "3.5rem", marginTop: "7px" }}
                />
              </Link>
            </Box>
            <Box display="flex" alignItems="right">
              <Box sx={{ typography: "body1" }}>
                <Link component={RouterLink} to="/pmt/about">About</Link>
              </Box>
            </Box>
          </Toolbar>
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              margin: "0 auto", // Center horizontally
              marginTop: "4.5rem",
              padding: "0px",
              borderTop: "1px solid #ccc",
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              justifyContent: "left"
            }}
          >
            <img
              src="/pmt/eu-logo.jpg"
              alt="Eu-Logo"
              style={{ height: "1.3rem", marginRight: "0.5rem" }}
            />
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{ lineHeight: "1.2", marginTop: "0.3rem", fontSize: "smaller" }}
            >
              Copyright © {currentYear}{" "}
              <Link href="https://quantifarm.eu/" target="_blank">
                QuantiFarm
              </Link>{" "}
              has received funding from the European Union&apos;s Horizon Europe Work
              Programme 2023-2024 under grant agreement <b>No. 101059700.</b>
            </Typography>
          </Box>
        </AppBar>
          <Toolbar/>
        <AppRoutes />
      </Router>
    </>
  );
}

export default App;
